export type ExterneHoedanigheid = 'ANDERE' | 'BEGELEIDER_PERSONEELSLID' | 'JONGERE';
